import { h } from 'preact'
import { useEffect } from 'preact/hooks'

// Swiper JS
import Swiper from 'swiper'
import { Autoplay, EffectCoverflow, Navigation, Pagination } from 'swiper/modules'
import { attributesAnalytics } from '../../js/modules/component'

export const BonsPlans = ({ titleCarrousel, slides, cacheKey }) => {
   let swiper_bonPlan

   useEffect(() => {
      swiper_bonPlan = new Swiper('.swiper-bonPlan', {
         modules: [Autoplay, EffectCoverflow, Navigation, Pagination],

         navigation: {
            enabled: false,
            nextEl: '.swiper-button-aloha-next',
            prevEl: '.swiper-button-aloha-prev',
         },

         pagination: {
            enabled: true,
            el: '.swiper-pagination',
            clickable: true,
            bulletClass: 'swiper-pagination-aloha',
            bulletActiveClass: 'swiper-pagination-aloha-active',
            horizontalClass: 'swiper-pagination-aloha-horizontal',
            renderBullet: function (index, className) {
               return '<span class="' + className + '"><span></span></span>'
            },
         },

         // Effet coverflow (opacité droite/gauche)
         effect: 'coverflow',
         coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 0,
            modifier: 2,
            slideShadows: true,
         },

         loop: true,
         autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
         },
         touchStartPreventDefault: false,
         preventClicks: false,
         spaceBetween: 15,
         centeredSlides: true,
         slidesPerView: 'auto',
         breakpoints: {
            736: {
               // when window width is >= 736px
               spaceBetween: 30,
               pagination: {
                  enabled: true,
               },
               navigation: {
                  enabled: true,
               },
            },
         },
        //  on: {
        //     click: function (swiper, e) {
        //        // Analytics manuel car les events 'click gauche' sont bloqués par swiper
        //        if (swiper.clickedSlide && swiper.clickedSlide.classList.contains('swiper-slide-active')) {
        //           if (typeof o_link === 'function') {
        //              let parentDataset = e.target.parentNode.dataset
        //              o_link({
        //                 track_refZ: JSON.parse(parentDataset.manualOther).track_refZ,
        //                 track_zone: parentDataset.manualCategory,
        //                 track_nom: parentDataset.manualAction,
        //                 track_cible: parentDataset.manualLabel,
        //              })
        //           }
        //        }
        //     },
        //  },
      })
   }, [])

   const slideOnClick = (e) => {
      const slideElement = e.target.closest('.slide')
      if (slideElement.classList.contains('swiper-slide-next')) {
         e.preventDefault()
         swiper_bonPlan.slideNext()
      }
      if (slideElement.classList.contains('swiper-slide-prev')) {
         e.preventDefault()
         swiper_bonPlan.slidePrev()
      }
   }

   const slideToView = (e) => {
      const slideElement = e.target.closest('.slide')
      if (slideElement) {
         const index = Array.from(slideElement.parentNode.children).indexOf(slideElement)
         swiper_bonPlan.autoplay.stop()
         swiper_bonPlan.slideTo(index)
      }
   }

   const resetSlider = (e) => {
      const slideElement = e.target.closest('.slide')
      if (slideElement) {
         swiper_bonPlan.autoplay.start()
         const centerSlideIndex = Math.floor(slideElement.parentNode.children.length / 2)
         swiper_bonPlan.slideTo(centerSlideIndex)
      }
   }

   const toggleAutoplay = (e) => {
      const ariaLabelPlay = 'Reprendre la lecture du carrousel'
      const ariaLabelPause = 'Mettre en pause le carrousel'
      if (swiper_bonPlan.autoplay.running) {
         swiper_bonPlan.autoplay.stop()
         e.target.classList.remove('swiper-playpause--pause')
         e.target.classList.add('swiper-playpause--play')
         e.target.setAttribute('aria-label', ariaLabelPlay)
      } else {
         swiper_bonPlan.autoplay.start()
         e.target.classList.remove('swiper-playpause--play')
         e.target.classList.add('swiper-playpause--pause')
         e.target.setAttribute('aria-label', ariaLabelPause)
      }
   }

   return (
      <div class="bons-plans mt-2 mt-xl-3 mb-1 mb-md-3" data-cache-key={cacheKey}>
         <h2 class="no-signature title">{titleCarrousel}</h2>
         <div class="swiper-bonPlan">
            <div class="swiper-wrapper">
               {slides.map((slide, index) => (
                  <Slide key={index} {...slide} slideOnClick={slideOnClick} slideToView={slideToView} resetSlider={resetSlider} />
               ))}
            </div>
            <div class="swiper-pagination" aria-hidden="true"></div>
            <button class="swiper-button-aloha swiper-button-aloha-prev" aria-label="précédent" tabindex="-1">
               <span class="icon-arrow-previous"></span>
            </button>
            <button class="swiper-button-aloha swiper-button-aloha-next" aria-label="suivant" tabindex="-1">
               <span class="icon-arrow-next"></span>
            </button>
            <button type="button" class="swiper-playpause swiper-playpause--pause" aria-label="Mettre en pause le carrousel" onClick={toggleAutoplay}></button>
         </div>
      </div>
   )
}

const Slide = ({ badge, date, dateColor, image, alt, URL, analytics, slideOnClick, slideToView, resetSlider }) => {
   return (
      <div class="swiper-slide slide" onClick={slideOnClick}>
         <a
            href={URL}
            {...attributesAnalytics(analytics)}
            class="slide-content"
            onFocus={slideToView}
            onBlur={resetSlider}
         >
            <img src={`${image}?saveas=webp`} alt={alt || ''} loading="lazy" />
            {(badge || date) && (
               <div class="top">
                  {badge && <span class="ob1-tag ob1-tag-primary">{badge}</span>}
                  {date && <span class={`date ${dateColor === 'white' ? 'text-white' : 'text-dark'}`}>{date}</span>}
               </div>
            )}
         </a>
      </div>
   )
}
